import { sanitizeStringWithSpaces } from "./text";

export const TEXT_ATTRIBUTES = ["title", "aria-label", "aria-labelledby", "aria-describedby", "placeholder", "legend", "label"];
export const EL_ATTRIBUTES = ["id", "class", "role", "jsaction", "ng-controller", "data-bind", "ng-model", "v-model", "v-bind", "data-testid", "href"];
export const FORM_ATTRIBUTES = [EL_ATTRIBUTES, "name", "action"].flat();
export const FIELD_ATTRIBUTES = [EL_ATTRIBUTES, "name", "inputmode"].flat();

/* given an element and a list of attribute names:
 * extracts and sanitizes them for further processing*/
export const getAttributes =
  (attributes: string[]) =>
  (el: HTMLElement): string[] =>
    (
      attributes
        .filter((key) => key !== "data-fathom")
        .map((attr) => el.getAttribute(attr))
        .filter(Boolean) as string[]
    ).map(sanitizeStringWithSpaces);

export const getBaseAttributes = getAttributes(EL_ATTRIBUTES);
export const getTextAttributes = getAttributes(TEXT_ATTRIBUTES);
export const getFieldAttributes = getAttributes(FIELD_ATTRIBUTES);
export const getFormAttributes = getAttributes(FORM_ATTRIBUTES);
